import styled from "styled-components";

export const SurveyList = styled.div`
  height: 100%;
  position: relative;
  .list {
    &__results {
      color: #C0BFDC;
      font-family: "Nunito Sans";
      font-size: 17px;
      font-style: italic;
      &--hidden {
        /* visibility: hidden; */
        display: none;
      }
    }
    &__container {
      overflow: auto;
      height: 100%;
    }
  }
`

export const ItemSurveys = styled.div`
  .item {
    box-sizing: border-box;
    display: flex;
    margin: 10px 0px; 
    border-radius: 20px;
    padding: 10px;
    width: 100%;
    background-color: ${({disabled}) => disabled ? "#F7F8FA" : "#EDEBF7" };
    font-family: Nunito Sans;
    color: ${({disabled}) => disabled ? "#3E3E5B" : "#1F1F52" } ; 
    outline: none;
    border: none;
    cursor: ${({ disabled}) =>  disabled ? "default" : "pointer" };
    justify-content: space-between;
    &__left {
      display: flex;
      align-items: center;
      width: 100%;
    }
    &__subtitle {
      font-size: 12px;
      color: ${({disabled}) => disabled ? "#3E3E5B" : "#707582" }; 
    }
    &__title {
      font-size: 14px;
      color: ${({selected}) => selected ? "#1168FF" : "#1F1F52"};
      font-family: ${({selected}) => selected ? "Nunito Sans bold" : "Nunito Sans"};
    }
    &--disabled {
      background-color: #F7F8FA;
      cursor: default;
      color: #707582;
      opacity: 0.45;
    }
    &--selected {
      color: #1168FF;
      font-family: Nunito Sans bold;
    }
    &__radio-button {
      border-radius: 50%;
      width: 20px;
      height: 20px;
      border: 1.2px solid ${({ disabled}) =>  disabled ? "#CFD3DD" : "#2A28D6"};
      background-color: ${({ disabled}) => disabled ? "#70758242" : "#FFFFFF"};
      padding: 3px;
      box-sizing: border-box;
      display: flex;
      margin-right: 5px;
      &-content {
        width: 14px;
        border-radius: 50%;
        background-color: #1168FF;
        display: ${({selected}) => selected ? "block" : "none"};
      }
    }
  }
`